import { axios } from '@/utils/request'
import { mockRepaymentReport, useMock } from '@/webpublicapi/_mock'

export function getVipList(parameter = {}) {
  return axios({
    url: 'vip/list',
    method: 'post',
    data: parameter
  })
}